import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GlobeIcon from '../../assets/icons/globe.svg';
import { APP_LANGUAGES } from '../../app.config.vars/languages';
import Input from '../../ui/Input';
import { getTranslation } from '../../api/admin/translate';
import { useAppDispatch } from '../../store';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import Loader from '../../ui/Loader';
import RichTextEditor from '../../ui/RichTextEditor';
const TranslatedFieldsRow = ({ fieldName, textarea, values, onChange, refs, formErrors, placeholder, originContent, isDataReady, rteButtons, }) => {
    const { i18n, t } = useTranslation();
    const dispatch = useAppDispatch();
    const [translationStatus, setTranslationStatus] = useState({});
    const translate = async (language) => {
        setTranslationStatus((prev) => ({ ...prev, [language]: 'pending' }));
        try {
            const res = await getTranslation({
                content: originContent,
                language: language === 'en' ? 'en-GB' : language,
            });
            setTranslationStatus((prev) => ({ ...prev, [language]: 'success' }));
            onChange(language, res.translation);
            if (refs) {
                const refKey = `${fieldName}${language.toUpperCase()}`;
                const fieldRef = refs[refKey];
                if (fieldRef && typeof fieldRef === 'object' && 'current' in fieldRef) {
                    const element = fieldRef.current;
                    if (element) {
                        // special case jo jodit
                        if ('selection' in element &&
                            element.selection &&
                            typeof element.selection.focus === 'function') {
                            element.selection.focus();
                        }
                        else if ('focus' in element && typeof element.focus === 'function') {
                            element.focus();
                        }
                    }
                }
            }
        }
        catch (error) {
            setTranslationStatus((prev) => ({ ...prev, [language]: 'error' }));
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return APP_LANGUAGES.map((lang) => {
        if (i18n.language !== lang.code) {
            return (_jsxs("div", { className: "translation-field-row", children: [_jsxs("div", { className: "translation-field-row-label", children: [_jsx("div", { className: "translation-field-row-icon", children: _jsx(GlobeIcon, {}) }), _jsx("div", { className: "translation-field-row-lang", children: t(`label.${lang.code}`) })] }), _jsxs("div", { className: "translation-field-row-input", children: [textarea ? (_jsx(RichTextEditor, { id: `${fieldName}-${lang.code}`, ref: refs ? refs[`${fieldName}${lang.code.toUpperCase()}`] : undefined, placeholder: t('placeholder.description'), value: values[lang.code] || '', onChange: (value) => onChange(lang.code, value), buttons: rteButtons, additionalContent: values[lang.code]
                                    .replace(/<p><br><\/p>/gi, '')
                                    .replace(/&nbsp;/g, '')
                                    .trim() ? undefined : translationStatus[lang.code] ===
                                    'pending' ? (_jsx(Loader, {})) : (_jsx("div", { className: "link-button translation-field-row-button", onClick: () => translate(lang.code), tabIndex: 0, onKeyDown: async (event) => {
                                        if (event.code === 'Space') {
                                            event.preventDefault();
                                            await translate(lang.code);
                                        }
                                    }, children: t('label.automatic_translation') })), error: !!formErrors[`${fieldName}${lang.code.toUpperCase()}`]?.length, errorMessage: formErrors[`${fieldName}${lang.code.toUpperCase()}`]?.length
                                    ? t(formErrors[`${fieldName}${lang.code.toUpperCase()}`][0]
                                        .messageTranslationKey, formErrors[`${fieldName}${lang.code.toUpperCase()}`][0]
                                        .variableToUseInMessage)
                                    : undefined, isDataReady: !!isDataReady })) : (_jsx(Input, { ref: refs ? refs[`${fieldName}${lang.code.toUpperCase()}`] : undefined, id: `${fieldName}-${lang.code}`, value: values[lang.code] || '', name: `${fieldName}${lang.code.toUpperCase()}`, textarea: textarea, placeholder: placeholder ? placeholder : t(`placeholder.${fieldName}`), onChange: (event) => onChange(lang.code, event.currentTarget.value), additionalContent: values[lang.code] ? undefined : translationStatus[lang.code] ===
                                    'pending' ? (_jsx(Loader, {})) : (_jsx("div", { className: "link-button translation-field-row-button", onClick: () => translate(lang.code), tabIndex: 0, onKeyDown: async (event) => {
                                        if (event.code === 'Space') {
                                            event.preventDefault();
                                            await translate(lang.code);
                                        }
                                    }, children: t('label.automatic_translation') })), error: !!formErrors[`${fieldName}${lang.code.toUpperCase()}`]?.length, errorMessage: formErrors[`${fieldName}${lang.code.toUpperCase()}`]?.length
                                    ? t(formErrors[`${fieldName}${lang.code.toUpperCase()}`][0]
                                        .messageTranslationKey, formErrors[`${fieldName}${lang.code.toUpperCase()}`][0]
                                        .variableToUseInMessage)
                                    : undefined })), _jsx("div", { className: "link-button translation-field-row-button", onClick: () => { }, tabIndex: 0, children: t('label.automatic_translation') })] })] }, lang.code));
        }
        else {
            return null;
        }
    });
};
export default TranslatedFieldsRow;
